// extracted by mini-css-extract-plugin
export default {"cameras-wrapper":"CamerasPage_cameras-wrapper__70i4T","video":"CamerasPage_video__D8nHi","camera":"CamerasPage_camera__Ba4c+"};